import { render, staticRenderFns } from "./CptsTransactionItem.vue?vue&type=template&id=37d810e0"
import script from "./CptsTransactionItem.vue?vue&type=script&lang=js"
export * from "./CptsTransactionItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports